<template>
  <div
    class="bg-white p-4 rounded border-grey"
    :class="[
      { 'shadow': shadow },
      { 'border-b': show_border },
      { 'mb-4': show_bottom_margin },
    ]"
  >
    <div
      class="pb-1 flex items-center justify-between"
      :class="{ 'cursor-pointer clickable': dropdown }"
      @click="dropdown && toggleDropdown()"
      tabindex="0"
    >
      <div class="flex flex-row items-center">
        <div v-if="icon" class="h-14 w-14 ml-2 mr-4 flex items-center justify-center">
          <img
            :src="icon"
            alt="icon"
            class="h-10 object-contain"
          />
        </div>

        <div class="flex flex-col justify-center">
          <div class="text-md font-bold leading-tight">
            {{ title }}
          </div>

          <div
            v-if="value"
            class="text-sm text-gray-600 mt-1 leading-tight flex items-center"
          >
            <span>{{ show_account ? value : maskedValue }}</span>
            <img
              :src="require(`@/assets/icons/${
                show_account
                  ? 'papsi_password_visible.svg'
                  : 'papsi_password_invisible.svg'
              }`)"
              alt="Toggle visibility"
              class="w-4 h-4 ml-2 cursor-pointer"
              @click.stop="toggleAccountVisibility"
            />
          </div>
        </div>
      </div>

      <img
        v-if="dropdown"
        src="@/assets/icons/papsi_dropdown.svg"
        class="w-5 h-5 mr-2 transition-transform duration-200"
        :class="{ 'rotate-180': show_content }"
      />
    </div>

    <transition name="fade">
      <div
        v-show="!dropdown || show_content"
        class="border-t text-sm mt-2 pt-2"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SettingCardControl",
  props: {
    title: String,
    value: String,
    icon: String,
    dropdown: {
      type: Boolean,
      default: false,
    },
    toggle: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    show_border: {
      type: Boolean,
      default: true, 
    },
    show_bottom_margin: {
      type: Boolean,
      default: true, 
    },
  },
  data() {
    return {
      show_content: false,
      show_account: false,
    };
  },
  computed: {
    maskedValue() {
      if (!this.value) return "";
      const visible = this.value.slice(-4);
      const hidden = this.value.slice(0, -4).replace(/\d/g, "*");
      return hidden + visible;
    },
  },
  methods: {
    toggleDropdown() {
      if (this.dropdown) {
        this.show_content = !this.show_content;
      }
    },
    toggleAccountVisibility() {
      this.show_account = !this.show_account;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.rotate-180 {
  transform: rotate(180deg);
}
</style>
